import fetch from "@lib/fetch";
import { API } from "../../config";
import axios from "axios";

export const getCatalog = (token) => {
    return fetch(`${API}/v1/catalogs`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const createForm = (token,catalogId) => {
    return fetch(`${API}/v1/catalogs/${catalogId}/forms`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const getPublicCatalog = (catalogId, catalogName) => {
    return fetch(`${API}/v1/catalogs/f/${catalogId}/${catalogName}`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const createCatalog = (token, data) => {
    return fetch(`${API}/v1/catalogs`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const updateCatalog = (token, catalogId, data) => {
    return fetch(`${API}/v1/catalogs/${catalogId}`,{
        mode: 'cors',
        method: "PUT",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const updateCategories = (token, catalogId, data) => {
    return fetch(`${API}/v1/catalogs/${catalogId}/categories`,{
        mode: 'cors',
        method: "PUT",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const updateCatalogHeaderImage = async (token, catalogId, image) => {
    const data = new FormData();
    data.append('headerImage', image);
    const res = await axios.post(`${API}/v1/catalogs/${catalogId}/image`, data, {
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
        }
    });
    if(res.data.success) {
        return res.data
    } else {
        alert(res.data.message);
    }
};